module.exports = __webpack_public_path__ + "static/media/hero-1-circle-3.b8f78470.png";